var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "VsButton",
    {
      staticClass: "profile-actions-button",
      attrs: {
        href: _vm.action.url,
        icon: _vm.action.icon,
        tracker: _vm.action.tracker
      },
      on: { click: _vm.action.action }
    },
    [_vm._v("\n  " + _vm._s(_vm.action.label) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }